import { c as _c } from "react/compiler-runtime";
import SaveIcon from '@mui/icons-material/Save';
export const Save = t0 => {
  const $ = _c(6);
  const {
    onClick
  } = t0;
  if (onClick) {
    let t1;
    if ($[0] !== onClick) {
      t1 = <SaveIcon aria-label="Save Icon" onClick={onClick} />;
      $[0] = onClick;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      background: "none",
      border: "none",
      padding: 0,
      cursor: "pointer"
    };
    t2 = <SaveIcon aria-label="Save Icon" />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== onClick) {
    t3 = <button type="submit" aria-label="Save Button" onClick={onClick} style={t1}>{t2}</button>;
    $[4] = onClick;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};